import {
    RETRIEVE_RESPONSIBLE_CASE_ID
} from "../../actions/types";
const initialState = [];

function responsibleReducer(responsible = initialState, action) {
    const {type, payload} = action;
    switch (type) {
        case RETRIEVE_RESPONSIBLE_CASE_ID:
            return payload;
        default:
            return responsible;
    }
}

export default responsibleReducer;